module.exports = __webpack_public_path__ + "img/68907.03b5008a.svg";